import { useTradePanel } from "@/components/trade-panel/hooks/use-trade-panel";
import { useEventConnect } from "@/store/eventConnect";
import { resolveUnitPriceNumber } from "@/utils/price";
import { get } from "@/utils/utils";
import { usePathname } from "next/navigation";

/**
 * Cash Out 业务逻辑 Hook
 *
 * 功能：
 * - 打开交易面板进行卖出操作
 * - 计算最佳卖出价格（基于订单簿）
 *
 * @param event - 事件信息
 * @param guessNo - 竞猜编号
 * @param positionItems - 持仓列表
 * @returns 处理函数
 */
export function useCashOut( event: any, guessNo: string, _positionItems: any[] ) {
    const { open: openTradePanel } = useTradePanel();
    const pathname = usePathname();

    // const currentGuessData = useEventConnect(state => state.guesses[guessNo]);
    const handleOpenCashOut = ( item: any ) => {
        const guessNoValue = get( item, "guessNo", guessNo );
        const guessRealtimeData = useEventConnect.getState().guesses;
        const currentGuessData = guessRealtimeData[guessNoValue] || guessRealtimeData[guessNo];
        const yesRealtimePrice = currentGuessData?.yesPrice ?? get( item, "yesRealtimePrice", 0 );
        const noRealtimePrice = currentGuessData?.noPrice ?? get( item, "noRealtimePrice", 0 );
        const guessTypeValue = get( item, "guessType", 1 );
        const direction = guessTypeValue === 1 ? "yes" : "no";
        // 成本 cost
        openTradePanel( {
            eventInfo: event,
            guessInfo: {
                groupTitle: get( item, "groupTitle", "" ),
                guessNo: guessNoValue,
                guessTitle: item.guessTitle || get( event, "eventTitle", "" ),
                title: item.guessTitle || get( event, "eventTitle", "" ),
                yesRealtimePrice,
                noRealtimePrice,
                imageUrl: item.guessImageUrl || get( event, "eventImageUrl", "" ),
            },
            positionInfo: item,
            tradeType: "sell",
            selectedOption: direction,
            sellAll: true,
            shares: item.shares,
            pathname,
            cost: item.price || 0,
            costShares: item.shares,
            limitPrice: resolveUnitPriceNumber( guessTypeValue === 1 ? yesRealtimePrice : noRealtimePrice ),
        } );
    };

    return { handleOpenCashOut };
}
